"use client";

import { useCallback, useEffect, useState } from "react";
import { useCheckPermissions } from "./useCheckPermissions";
import { useAccountActionPermissions } from "./useAccountActionPermissions";

/** Returns what actions a user can perform on an Agent. */
export function useAgentActionPermissions(agentId: string) {
  // a toggleable state to opt in for fetching permissions
  const [permissionsCheckEnabled, setPermissionsCheckEnabled] = useState(false);
  const enablePermissionsCheck = useCallback(() => {
    setPermissionsCheckEnabled(true);
  }, []);

  const { permissions, checkPermissions, isLoading } = useCheckPermissions({
    assetId: agentId,
    assetType: "agent",
    permissionLevels: ["can_edit", "can_delete", "can_change_owner"],
  });

  const { allowTeams: hasTeams } = useAccountActionPermissions();

  // Only check permissions if the user has enabled the check
  // and the permissions have not been fetched yet
  useEffect(() => {
    if (permissionsCheckEnabled && !permissions && !isLoading) {
      checkPermissions();
    }
  }, [isLoading, permissions, permissionsCheckEnabled, checkPermissions]);

  return {
    canDelete: permissions?.canDelete || false,
    canMove: permissions?.canEdit || false,
    canRename: permissions?.canEdit || false,
    canChangeOwner: (permissions?.canChangeOwner && hasTeams) || false,
    canShare: (permissions?.canEdit && hasTeams) || false,
    enablePermissionsCheck,
    isLoading,
    hasTeams,
  };
}
